/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

export const REQUESTED_IRT_MESSAGES = 'REQUESTED_IRT_MESSAGES';
export const requestedIRTMessages = () => {
  return {
    type: REQUESTED_IRT_MESSAGES
  };
};

export const RECEIVED_IRT_MESSAGES = 'RECEIVED_IRT_MESSAGES';
export const receivedIRTMessages = (messaging) => ({
  type: RECEIVED_IRT_MESSAGES,
  messaging
});

export const ERROR_IRT_MESSAGES = 'ERROR_IRT_MESSAGES';
export const errorIRTMessages = (error) => ({
  type: ERROR_IRT_MESSAGES,
  error
});

export const SUPPRESSED_IRT_MESSAGE = 'SUPPRESSED_IRT_MESSAGE';
export const suppressedIRTMessage = (response) => ({
  type: SUPPRESSED_IRT_MESSAGE,
  response
});

export const HAS_SEEN_IRT_MESSAGE = 'HAS_SEEN_IRT_MESSAGE';
export const hasSeenIrtMessage = (messaging) => ({
  type: HAS_SEEN_IRT_MESSAGE,
  messaging
});
